import { render } from "./LegacyPrescriptionInterceptModal.vue?vue&type=template&id=16dfb19a&scoped=true"
import script from "./LegacyPrescriptionInterceptModal.vue?vue&type=script&lang=js"
export * from "./LegacyPrescriptionInterceptModal.vue?vue&type=script&lang=js"

import "./LegacyPrescriptionInterceptModal.vue?vue&type=style&index=0&id=16dfb19a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16dfb19a"]])

export default __exports__